import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export type EmailComposerView = 'templates' | 'template-editor' | 'components' | 'component-editor' | 'themes' | 'theme-editor' | 'actions' | 'action-editor'

@Injectable({ providedIn: 'root' })
export class EmailComposerStateService {
  private activeViewSubject = new BehaviorSubject<EmailComposerView>('templates')
  private searchSubject = new BehaviorSubject<string>('')

  activeView$ = this.activeViewSubject.asObservable()
  search$ = this.searchSubject.asObservable()

  setActiveView(view: EmailComposerView) {
    this.activeViewSubject.next(view)
  }

  setSearch(value: string) {
    this.searchSubject.next(value)
  }
}
